export default {
  namespaced: true,
  state: {
    app_version: '2.1.12'
  }
}
